/**
 * List of special characters including '[]&\#+()$~%*?,<>{}'
 */
const specialCharacters = /[\[\]&\\#+()$~%*?,<>{}]/

export { specialCharacters }



// WEBPACK FOOTER //
// ./src/utilities/regex/special-characters.js